import React from "react";
import UIAccordion from '../ui-components/surface/UIAccodion';
import Section from '../Section';
import parse from 'html-react-parser'
import styles from '../../../styles/modules/common/Faq.module.scss';
import { faqClicked } from "../../../tracking/segment/planPage";
import { getSelectedCityFromCookie } from "../../../utils/cities";
import { getPageURL } from "../../../utils/tracking";
import { filterQuestionsForCampaign } from "../../../utils";


interface Props {
  questions: {
    title:string,
    answer:string,
    links:string,
    is_blog:boolean
  }[],
  title: string,
  className?:string,
  page_url?:string,
  category?:string,
  pineLabs?:boolean
}

const FaqJSX = (props:Props) => {
  const { questions , className } = props;
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const handleChange = (panel: string, question: string) => (isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
    faqClicked({...getPageURL(), 'faq_question':question, 'location':getSelectedCityFromCookie(),'category':props.category})
  };
  let filtered_questions = questions
  if (props.pineLabs) filtered_questions = filterQuestionsForCampaign(questions)
  return (
    <Section title={props.title} className={`faq ${className? className : ''}`.trim()} id="faqs" hasPadding={true} dataBg="shade-1">
      <div className="container">
        <div className="faq-wrap">
        {filtered_questions && filtered_questions.map((question, index) => <UIAccordion key={index.toString()} expanded={expanded === `panel${index}`} onChange={handleChange(`panel${index}`,question.title)} title={question.title} simple={true}> 
          <div itemProp="acceptedAnswer">
          <span className={styles.table}>
            {parse(question.answer)} 
            {question.links !== '' ? <a href={question.links}>Read More</a> : null} 
          </span>
          </div>
        </UIAccordion>)}
        </div>
      </div>
    </Section>
  )
}

export default FaqJSX;
